import { render } from "./CreateJourneySetInstructions.vue?vue&type=template&id=36194688&scoped=true"
import script from "./CreateJourneySetInstructions.vue?vue&type=script&lang=ts"
export * from "./CreateJourneySetInstructions.vue?vue&type=script&lang=ts"

import "./CreateJourneySetInstructions.vue?vue&type=style&index=0&id=36194688&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-36194688"

export default script